"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToUuid = void 0;
const textToUuid = (dirty) => {
    const replacements = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        a: "a",
        b: "b",
        c: "c",
        d: "d",
        e: "e",
        f: "f",
        i: "1",
        o: "0",
        s: "5",
        t: "7",
        l: "1",
        g: "6",
        q: "9",
        z: "2",
        m: "3",
        w: "3",
        h: "4",
        y: "4",
        x: "8",
        j: "9",
        p: "9",
        r: "4",
    };
    let clean = "";
    let count = 0;
    for (let i = 0; i < 32; i++) {
        if (i === 12) {
            clean += "4";
        }
        else if (i === 16) {
            clean += "a";
        }
        else {
            const char = dirty[i]?.toLowerCase();
            const replacement = char ? (replacements[char] ?? "0") : "0";
            clean += replacement;
        }
        count++;
        if (count === 8 || count === 12 || count === 16 || count === 20) {
            clean += "-";
        }
    }
    return clean;
};
exports.textToUuid = textToUuid;
//# sourceMappingURL=text-to-uuid.js.map